const request = async (url, data) => {
  const res = await fetch(url, {
    method: 'POST',
    body: data,
  });

  return res.text();
};

const searchWiki = (trigger, target) => {
  const form = document.querySelector(trigger);
  const { feag } = window;

  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();

      const targetElement = document.querySelector(target);
      const btn = form.querySelector('[data-search-wiki-submit]');
      const keyword = form.querySelector('[data-search-wiki-keyword]').value;

      const origBtnText = btn.innerText;
      btn.innerText = feag.namespace.loading;
      btn.classList.add('disabled');

      const formData = new FormData();
      formData.append('action', 'searchWiki');
      formData.append('keyword', keyword);

      request(feag.ajaxurl, formData).then(r => {
        btn.innerHTML = origBtnText;

        const resultWrap = targetElement.querySelector('.c-wiki__result');
        resultWrap.innerHTML = r;

        btn.classList.remove('disabled');
      });
    });
  }
};

const init = () => {
  window.addEventListener(
    'DOMContentLoaded',
    () => {
      searchWiki('[data-search-wiki-form]', '.c-wiki');
    },
    { once: true },
  );
};

init();
